import { Box, Typography } from "@mui/material";
import React from "react";

interface IDetailTitleProps {
  title: string;
  icon: React.ReactNode;
}

const DetailTitle = ({ title, icon }: IDetailTitleProps) => {
  return (
    <Box className="flex items-center gap-1">
      {icon}
      <Typography fontSize={14} fontWeight={600}>
        {title}
      </Typography>
    </Box>
  );
};

export default DetailTitle;
